'use client';

import { useMemo } from 'react';
import { ChirpIllustration } from '@chewy/chirp-media-kit';
import '@chewy/chirp-media-kit/illustration/styles.css';
import cn from 'classnames';
import styles from './DynamicIllustration.module.scss';
import { useConversation } from '@chewy/chat-library-common';
import { getUserAgentIllustration } from './illustrations';
import { toChirpEnv } from './utils/env';

export { ILLUSTRATIONS } from './illustrations';

export interface DynamicIllustrationProps {
    className?: string;
    agentUserId?: string;
}

export default function DynamicIllustration({ className, agentUserId }: DynamicIllustrationProps) {
    const { env, sessionId } = useConversation();

    const illustration = useMemo(() => {
      const value = (agentUserId ?? '') + (sessionId ?? '');
      return getUserAgentIllustration(value)
    }, [agentUserId, sessionId]);

    return <ChirpIllustration className={cn(styles.illustration, className)} name={illustration} env={toChirpEnv(env)} isDecorative={true} />;
}
